import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
// hooks
import { useCoverageData } from 'src/components/screens/hooks';
// components
import { colors } from 'design-system';
import { capitalize } from 'lodash';
import { CardIndividualProps } from './CardIndividual';
import DeductibleDetailRow from './DeductibleDetailRow';

const useStyle = makeStyles(() => ({
  container: {
    marginTop: 25,
  },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  titleSection: { paddingBottom: 7, marginBottom: 20 },
  logo: { marginRight: 11 },
  tooltipRoot: {
    maxWidth: 130,
    color: colors.madison,
    backgroundColor: 'white',
    fontSize: 13,
    fontWeigh: 500,
    border: '1px solid #00',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
  },
  tooltipArrow: {
    color: 'white',
  },
}));

const IndividualDeductiblesResume = ({
  coverageCatalogs,
  coverageCatalogResumes,
  unit,
  moneyType,
  packageOption,
  quotation,
}: CardIndividualProps): JSX.Element => {
  const classes = useStyle();
  const { deductibleResume } = useCoverageData({
    coverageCatalogResumes,
    coverageCatalogs,
    unit,
    moneyType,
    packageOption,
    createdAt: quotation.createdAt,
  });

  return (
    <>
      <Box display="flex">
        <img
          src="svg/deductible.svg"
          alt="deductible_icon"
          className={classes.logo}
          data-testid="icon-image"
        />
        <Typography className={classes.titleText} data-testid="title-text">
          Deducibles
        </Typography>
      </Box>

      <Grid item className={classes.container}>
        {deductibleResume
          .filter((item) => item.code !== '0058')
          .map(({ code, value, name, helperText, showHelper }) => (
            <DeductibleDetailRow
              data-testid={`deductible-${code}`}
              key={code}
              description={capitalize(name)}
              value={value}
              helperText={helperText}
              showHelper={showHelper}
            />
          ))}
      </Grid>
    </>
  );
};

export default IndividualDeductiblesResume;
